// extracted by mini-css-extract-plugin
export default {"postContainer":"Post_postContainer__mIQ3t"};